import React from 'react';
import ReactDOM from 'react-dom';
import HeaderAboutMe from './components/HeaderAboutMe';
import SectionAboutMe from './components/SectionAboutMe';
import UpdateDetails from './components/UpdateDetails';
import SkillBox from "./components/SkillBox";
import LoadingScreen from "./components/LoadingScreen";
import './css/style.css';
import './css/icofont.min.css';
import App from './App';
import Skill from './components/Skill';
import base from "./base";
import * as serviceWorker from './serviceWorker';

var HeaderAboutMeisLoading = true;
var SectionAboutMeisLoading = true;
var SkillboxisLoading = true;
var loadingRemoved = false;

ReactDOM.render(<LoadingScreen/>,
  document.getElementById('loading-screen')
);

function handleChangeHeaderAboutMe(event) {
  if(event != null) {
    HeaderAboutMeisLoading = false;
  }

  if(HeaderAboutMeisLoading==false && SectionAboutMeisLoading==false && SkillboxisLoading==false && loadingRemoved==false) {
    loadingRemoved = true;
    ReactDOM.render(null, document.getElementById('loading-screen'));
    document.getElementsByClassName('header-heading')[0].style.animation = "moveInBottom 1s forwards";
    document.getElementsByClassName('header-about-me')[0].style.animation = "moveInBottom 1s 0.75s forwards";
  }
}

function handleChangeSectionAboutMe(event) {
  if(event != null) {
    SectionAboutMeisLoading = false;
    //document.getElementsByClassName('section-about-me')[0].style.height = "auto";
  }

  if(HeaderAboutMeisLoading==false && SectionAboutMeisLoading==false && SkillboxisLoading==false && loadingRemoved==false) {
    loadingRemoved = true;
    ReactDOM.render(null, document.getElementById('loading-screen'));
    document.getElementsByClassName('header-heading')[0].style.animation = "moveInBottom 1s forwards";
    document.getElementsByClassName('header-about-me')[0].style.animation = "moveInBottom 1s 0.75s forwards";
  }
}

function handleChangeSkillbox(event) {
  if(event != null) {
    SkillboxisLoading = false;
  }

  if(HeaderAboutMeisLoading==false && SectionAboutMeisLoading==false && SkillboxisLoading==false && loadingRemoved==false) {
    loadingRemoved = true;
    ReactDOM.render(null, document.getElementById('loading-screen'));
    document.getElementsByClassName('header-heading')[0].style.animation = "moveInBottom 1s forwards";
    document.getElementsByClassName('header-about-me')[0].style.animation = "moveInBottom 1s 0.75s forwards";
  }
}

function handleUpdateDetailsClick(event) {
  event.preventDefault();
  if(document.getElementById('section-update-details').innerHTML === "") {
    document.getElementsByClassName('section-update-details-back')[0].style.opacity = "1";
    document.getElementsByClassName('section-update-details-back')[0].style.animation = "growIn 0.5s forwards";
    ReactDOM.render(<div className="update-details-main">
        <button  className="update-details-main-close-button" onClick={handleUpdateDetailsClick}>&#10005;</button>
        <UpdateDetails />
      </div>, document.getElementById('section-update-details'));
  }
  else {
    document.getElementsByClassName('section-update-details-back')[0].style.animation = "shrinkOut 0.25s forwards";
    ReactDOM.render(null, document.getElementById('section-update-details'));
  }
}

ReactDOM.render(<HeaderAboutMe onChange={handleChangeHeaderAboutMe}/>,
  document.getElementById('header-about-me-react')
);

ReactDOM.render(<SectionAboutMe onChange={handleChangeSectionAboutMe}/>,
  document.getElementById('section-about-me-react')
);
/*
ReactDOM.render(<UpdateDetails />,
document.getElementById('root')
);
*/

ReactDOM.render(<SkillBox onChange={handleChangeSkillbox}/>,
  document.getElementById('section-skills-skillbox')
);

ReactDOM.render(<button className="footer-content-button" onClick={handleUpdateDetailsClick}>Update Details</button>,
  document.getElementsByClassName('footer-content-button-section')[0]
);

/*
async function getDescription() {
  var homeDesc=null;
  var aboutMeDesc=null;

  const homepageDescription = await base.fetch('homepageDescription', {context: this}).then(res => {
    console.log(res);
    homeDesc = res;
  })
  //console.log("desc: " + homeDesc + "ITS TYPE: " + typeof(homeDesc));
  document.getElementsByClassName("header-about-me")[0].innerHTML = homeDesc;

  const aboutMeDescription = await base.fetch('aboutMeDescription', {context: this}).then(res => {
    console.log(res);
    aboutMeDesc = res;
  })
  console.log("desc: " + aboutMeDesc);
  document.getElementsByClassName("section-about-me-text")[0].innerHTML = aboutMeDesc;
  };
getDescription();
*/

function getProfilePhoto() {
  /*
  fetch('https://graph.facebook.com/nishantgoyal918/recently_searched_hashtags?limit=30')
  .then(function(r) {
    console.log(r);
  })
  */
  fetch('https://www.instagram.com/nishantgoyal918/?__a=1')
  .then(function(r) {
    return (r.json());
    //console.log(r.json());
  })
  .then(function(j) {
    return (j['graphql']['user']['profile_pic_url_hd']);
  })
  .then(function(url) {
    document.getElementById('section-about-me-img').src = url;
  })
}

getProfilePhoto();

window.onscroll = function() {
  if(document.body.scrollTop > ( window.innerHeight / 4 ) || document.documentElement.scrollTop > ( window.innerHeight / 4 ) ) {
    //alert("50 done");
    document.getElementsByClassName('section-about-me-title')[0].style.animation = "moveInBottom 1s forwards";
    document.getElementsByClassName('section-about-me-text')[0].style.animation = "moveInBottom 1s forwards 0.75s";
    document.getElementsByClassName('section-about-me-imgbox')[0].style.animation = "moveInBottom 1s forwards 0.75s";
    //document.getElementsByClassName('section-skills-title')[0].style.animation = "moveInBottom 1s forwards 0.75s";
  }
  else {
    document.getElementsByClassName('section-about-me-title')[0].style.animation = "moveOutTop 1s forwards";
    document.getElementsByClassName('section-about-me-text')[0].style.animation = "moveOutTop 1s forwards 0.75s";
    document.getElementsByClassName('section-about-me-imgbox')[0].style.animation = "moveOutTop 1s forwards 0.75s";
    //document.getElementsByClassName('section-skills-title')[0].style.animation = "moveOutTop 1s forwards 0.75s";
  }

  if(document.body.scrollTop > ( window.innerHeight) * 1.25 || document.documentElement.scrollTop > ( window.innerHeight) * 1.25 ) {
    //alert("50 done");
    document.getElementsByClassName('section-skills-title')[0].style.animation = "moveInBottom 1s forwards";
    document.getElementsByClassName('section-skills-skillbox')[0].style.animation = "moveInBottom 1s forwards 0.75";

  }
  else {
    document.getElementsByClassName('section-skills-title')[0].style.animation = "moveOutTop 1s forwards";
    document.getElementsByClassName('section-skills-skillbox')[0].style.animation = "moveOutTop 1s forwards 0.75";
    //document.getElementsByClassName('section-skills-skill')[0].style.animation = "moveInBottom 1s forwards 0.75s";
  }


}

function updateDetailsClicked() {
  alert("Clicked");
}

/*
async function getSkill() {
  const skillList = await base.fetch('skills', {context: this});
  ReactDOM.render(
    Object.keys(skillList).map(key => {
      return(<Skill key={key} icon={skillList[key]['icon']} link={skillList[key]['link']}/>);
    })
  , document.getElementById('section-skills-skillbox'));
  /*
  Object.keys(skillList).map(key => {
    ReactDOM.render(<Skill key={key} icon={skillList[key]['icon']} link={skillList[key]['link']}/>,
      document.getElementById('section-skills-skillbox')
    );

    //console.log(skillList[key]);
  });

}

getSkill();

*/
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
